import { useQuery } from "@tanstack/react-query"
import { profile } from  '@shared/api/services'

export const useAvailableInstruments = () => {
	return useQuery({
		queryKey: ['available-instruments'],
		queryFn: () => profile.getAvailableInstruments(),
		select: (data) => data.data
})
}